export default __webpack_public_path__ + "static/media/Apple-logo.5923fcb9.svg";